import { Sun, Moon } from "lucide-react";
import { useDarkMode } from "@halo/web-lib";

interface ModeColorSwitchProps {
  isOpen: boolean;
}

export function ModeColorSwitch({ isOpen }: ModeColorSwitchProps) {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <div className="flex items-center w-full">
      <button
        onClick={toggleDarkMode}
        className={`w-full flex items-center p-2 rounded-lg text-sm
          bg-warmSand-100 dark:bg-charcoalGray-800
          text-charcoalGray-500 dark:text-charcoalGray-200
          hover:bg-warmSand-200 dark:hover:bg-charcoalGray-700
          hover:text-charcoalGray-800 dark:hover:text-white
          transition-colors ${!isOpen ? "justify-center" : ""}`}
      >
        {isDarkMode ? (
          <Sun
            size={20}
            className={`flex-shrink-0 transition-all duration-300 ${isOpen ? "mr-2" : ""}`}
          />
        ) : (
          <Moon
            size={20}
            className={`flex-shrink-0 transition-all duration-300 ${isOpen ? "mr-2" : ""}`}
          />
        )}
        <span
          className={`transition-all duration-300 whitespace-nowrap ${isOpen ? "opacity-100" : "opacity-0 w-0 overflow-hidden pointer-events-none"}`}
        >
          {isDarkMode ? "Light Mode" : "Dark Mode"}
        </span>
      </button>
    </div>
  );
}
